import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { ChefHat, Lock } from "lucide-react";
import { api } from "@/lib/api";

export default function ResetPassword() {
  const params = new URLSearchParams(window.location.search);
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 4) { toast.error("Mot de passe trop court"); return; }
    if (password !== confirm) { toast.error("Les mots de passe ne correspondent pas"); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      toast.success("Mot de passe réinitialisé !");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Lien invalide ou expiré");
    } finally { setBusy(false); }
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-6" style={{ background: "var(--at-bg)" }} data-testid="reset-page">
      <div className="w-full max-w-sm">
        <div className="mb-8 text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-3xl text-white at-shadow-lg" style={{ background: "var(--at-brand)" }}>
            <ChefHat size={32} />
          </div>
          <h1 className="font-display text-3xl font-bold">Nouveau mot de passe</h1>
        </div>

        {!token ? (
          <p className="text-center text-sm" style={{ color: "var(--at-text-2)" }}>Lien invalide. Refaites une demande depuis l'écran de connexion.</p>
        ) : done ? (
          <div className="text-center">
            <p className="mb-4 text-sm" style={{ color: "var(--at-text-2)" }}>Votre mot de passe a été mis à jour.</p>
            <Button data-testid="go-login-btn" onClick={() => { window.location.href = "/"; }} className="h-12 w-full rounded-2xl font-semibold text-white" style={{ background: "var(--at-brand)" }}>
              Se connecter
            </Button>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-3">
            <div className="space-y-1.5">
              <Label className="text-xs font-semibold uppercase tracking-wide" style={{ color: "var(--at-muted)" }}>Nouveau mot de passe</Label>
              <div className="relative">
                <Lock size={17} className="absolute left-3.5 top-3.5" style={{ color: "var(--at-muted)" }} />
                <Input data-testid="new-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className="h-12 rounded-2xl border-black/10 bg-white pl-10" />
              </div>
            </div>
            <div className="space-y-1.5">
              <Label className="text-xs font-semibold uppercase tracking-wide" style={{ color: "var(--at-muted)" }}>Confirmer</Label>
              <div className="relative">
                <Lock size={17} className="absolute left-3.5 top-3.5" style={{ color: "var(--at-muted)" }} />
                <Input data-testid="confirm-password-input" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="••••••••" className="h-12 rounded-2xl border-black/10 bg-white pl-10" />
              </div>
            </div>
            <Button data-testid="reset-submit-btn" type="submit" disabled={busy} className="h-13 w-full rounded-2xl py-3 text-base font-semibold text-white at-shadow-lg at-press" style={{ background: "var(--at-brand)" }}>
              {busy ? "..." : "Réinitialiser"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
